import formInput from '../lib/formInput'

export async function takePhotoHandler(): Promise<File> {
  const file = await formInput()
  return file
}
